/* eslint-disable react/no-danger */
import React from 'react';
import { SageClassnames } from '@kajabi/sage-react';

import { useCheckout } from '../../context';
import { LoginSection } from './LoginSection';

export const Footer = () => {
  const {
    isTwoStepsSignupFirstStep,
    planInfo: { footer },
  } = useCheckout();

  if (isTwoStepsSignupFirstStep()) {
    return (
      <LoginSection />
    );
  }

  return (
    <p
      className={[
        SageClassnames.TYPE.BODY_SMALL_MED,
        SageClassnames.TYPE_COLORS.CHARCOAL_400,
      ].join(' ')}
      dangerouslySetInnerHTML={{ __html: footer }}
    />
  );
};
